"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayLiveUpdateInstallService = exports.DelayLiveUpdateInstallServiceConfig = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var ONE_MINUTE = 60 * 1000;
var ONE_HOUR = 60 * 60 * 1000;
var DelayLiveUpdateInstallServiceConfig = /** @class */ (function () {
    function DelayLiveUpdateInstallServiceConfig() {
        this.MIN_MS_HASH_CHANGE = ONE_MINUTE * 10;
        this.MIN_MS_FOREGROUND = ONE_HOUR * 3;
    }
    return DelayLiveUpdateInstallServiceConfig;
}());
exports.DelayLiveUpdateInstallServiceConfig = DelayLiveUpdateInstallServiceConfig;
var DelayLiveUpdateInstallService = /** @class */ (function () {
    function DelayLiveUpdateInstallService(config) {
        var _this = this;
        this.config = config;
        // mocked by tests
        this.clock = { now: function () { return Date.now(); } };
        this.onAppStart = function () {
            _this.appStartedAt = _this.clock.now();
            return { canInstall: false };
        };
        this.onBackground = function () {
            _this.lastBackgroundedAt = _this.clock.now();
        };
        this.onForeground = function () {
            if (!_this.lastBackgroundedAt) {
                return { canInstall: false };
            }
            var elapsed = _this.clock.now() - _this.lastBackgroundedAt;
            return { canInstall: elapsed >= _this.config.MIN_MS_FOREGROUND };
        };
        this.onHashChange = function () {
            if (!_this.appStartedAt) {
                return { canInstall: false };
            }
            var elapsedSinceAppStart = _this.clock.now() - _this.appStartedAt;
            return {
                canInstall: elapsedSinceAppStart >= _this.config.MIN_MS_HASH_CHANGE
            };
        };
        this.getCanInstallOnHashChangeAfter = function () {
            if (!_this.appStartedAt) {
                return undefined;
            }
            return (0, dayjs_1.default)(_this.appStartedAt + _this.config.MIN_MS_HASH_CHANGE).toISOString();
        };
        this.getCanInstallOnForegroundAfter = function () {
            if (!_this.appStartedAt) {
                return undefined;
            }
            return (0, dayjs_1.default)(_this.appStartedAt + _this.config.MIN_MS_FOREGROUND).toISOString();
        };
    }
    DelayLiveUpdateInstallService.inject = function () { return [DelayLiveUpdateInstallServiceConfig]; };
    return DelayLiveUpdateInstallService;
}());
exports.DelayLiveUpdateInstallService = DelayLiveUpdateInstallService;
//# sourceMappingURL=DelayLiveUpdateInstallService.js.map